import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import AppServiceCalc from '../components/calculators/AppServiceCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { CalculatorContentWrapper } from '../components/shared/CalculatorContentWrapper'
import { parseURLToAppService } from '../utils/urlState'
import { useCalculatorStore } from '../store/calculatorStore'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function AppServicePage() {
  const setAppServiceInputs = useCalculatorStore(s => s.setAppServiceInputs)

  useEffect(() => {
    const urlInputs = parseURLToAppService()
    if (urlInputs) {
      setAppServiceInputs(urlInputs as any)
    }
  }, [setAppServiceInputs])
  return (
    <>
      <Helmet>
        <title>Azure App Service Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Calculate Azure App Service costs for UK South. Compare Windows and Linux plans. Basic, Standard and Premium v3 tiers. Linux is typically 50% cheaper to run." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/app-service" />
        <meta property="og:title" content="Azure App Service Cost Calculator UK" />
        <meta property="og:description" content="Free independent Azure App Service pricing for UK South. Compare Linux vs Windows costs." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/app-service" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "Azure App Service Cost Calculator",
          "description": "Independent Azure App Service pricing calculator for UK South",
          "url": "https://www.azure-calc.co.uk/app-service",
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "GBP"
          }
        })}</script>
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([{ name: 'Home', url: '/', position: 1 }, { name: 'Azure App Service Calculator', url: '/app-service', position: 2 }]))}</script>
      </Helmet>
      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure App Service Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Windows and Linux · Premium v3 recommended
          </p>
        </div>
        <AppServiceCalc />
        <CalculatorContentWrapper
          eyebrow="App Service Pricing Guide"
          title="Understanding Azure App Service Costs"
          intro={(
            <>
              <p className="mb-3">
                Azure App Service pricing depends on your chosen tier, operating system, and scaling configuration.
                Premium v3 is Microsoft's recommended tier for production workloads, offering better performance and features.
              </p>
              <p>
                Current UK South pricing as of March 2026. Linux instances are typically 40-60% cheaper than Windows equivalents.
                All prices are per instance per hour.
              </p>
            </>
          )}
          sections={[
            {
              id: 'test',
              title: 'Test Section',
              body: <div>Test content</div>,
            },
          ]}
          methodologyNote="Test methodology note"
        />
      </div>
    </>
  )
}
